/**
 * @fileoverview Defines the `BlogImage` component, a React functional component, for displaying images with optional captions in blog posts. It uses the `BlogImageProps` interface to define the expected props. The component renders an image and its caption within a container.
 */

import React from 'react'
import '../styles/components/BlogImage.css'

interface BlogImageProps {
  src: string
  alt: string
  caption?: string
}

const BlogImage: React.FC<BlogImageProps> = ({ src, alt, caption }) => {
  return (
    <div className="blog-image-container">
      <img src={src} alt={alt} />
      {caption && <span>{caption}</span>}
    </div>
  )
}

export default BlogImage
